import Attachments from './Attachments';
import AttachmentButton from './AttachmentButton';

export default Attachments;
export { AttachmentButton };
